var rcp_refresh_interval = 90; // Seconds between auto refresh
var rcp_hp_fetching_data = false;
var rcp_hp_fetch_callbacks = [];

var E2020_PUB_PATH = '/elections/live_results/2020';

export {
    rcp_refresh_interval,
    rcp_hp_fetching_data,
    rcp_hp_fetch_callbacks,
    E2020_PUB_PATH,
};